// extracted by mini-css-extract-plugin
module.exports = {"divider":"AnnouncementsModal_divider__13f3Q"};